/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Injectable} from '@angular/core';

import {isPresent} from '../utils/lang';

/**
 * Single FIQL expression
 */
export interface Expression {
  name: string;
  value: string | SearchQuery;
  operator: string;
}

/**
 * Full search query
 */
export type SearchQuery = Array<Expression>;

export const encode = (query: string) => encodeURIComponent(query).replace(/[!'()*]/g,
  (characters: string) => '%' + characters.charCodeAt(0).toString(16));


/**
 * FIQL service that let us serialize search queries to string for sending to API endpoints
 */
@Injectable()
export class FiqlService {

  /**
   * Serializes a search query
   *
   * @param query the query to serialize
   * @param operator the combining operator to use to combine top-level query elements. Defaults to AND operator
   * @param encodeNeeded boolean to specify if we need to encode value
   * @returns {string} the serialized query
   */
  public serialize(query: SearchQuery, operator: string = ';', encodeNeeded: boolean = false): string {
    if (!isPresent(query)) {
      return '';
    }
    return query.map(filter => {
      if (Array.isArray(filter.value)) {
        if (filter.value.length > 1) {
          return `(${this.serialize(<SearchQuery>filter.value, filter.operator, encodeNeeded)})`;
        } else {
          return `${this.serialize(<SearchQuery>filter.value, filter.operator, encodeNeeded)}`;
        }
      } else {
        const filterValue = encodeNeeded ? encode(`'${filter.value}'`) : `'${filter.value}'`;
        return `${filter.name}${filter.operator}${filterValue}`;
      }
    }).join(operator);
  }

}
